"use strict";
const get = require('lodash/get');
const { v4: uuid } = require('uuid');
let asyncLocalStorage;
try {
    // eslint-disable-next-line global-require
    const { AsyncLocalStorage } = require('async_hooks');
    asyncLocalStorage = new AsyncLocalStorage();
}
catch (err) {
    // AsyncLocalStorage is not available (browser environment or older Node.js)
    // Gracefully continue without tracing functionality
    asyncLocalStorage = null;
}
const getTraceId = () => {
    const store = asyncLocalStorage ? asyncLocalStorage.getStore() : null;
    const tId = store ? store.get('traceId') : '';
    return (tId || uuid());
};
const getStoreProperty = (key) => {
    const store = asyncLocalStorage ? asyncLocalStorage.getStore() : null;
    return store ? store.get(key) : '';
};
const addPropsToContext = (props) => {
    const store = asyncLocalStorage ? asyncLocalStorage.getStore() : null;
    if (store) {
        Object.keys(props).forEach((key) => {
            store.set(key, props[key]);
        });
    }
};
const traceIdMiddleware = (req, res, next) => {
    if (asyncLocalStorage) {
        const traceId = get(req, 'headers.trace_id');
        const originalEndpoint = get(req, 'headers.original-app-route');
        asyncLocalStorage.run(new Map(), () => {
            const id = traceId || uuid();
            const store = asyncLocalStorage.getStore();
            store.set('traceId', id);
            store.set('originalEndpoint', originalEndpoint);
            const authedUser = req.USER;
            if (authedUser) {
                addPropsToContext({ authUserId: authedUser.uuid, serviceId: authedUser.service_id });
            }
            next();
        });
    }
    else {
        next();
    }
};
const runCbWithTraceId = (args, cb, traceId) => {
    if (asyncLocalStorage) {
        return asyncLocalStorage.run(new Map(), () => {
            asyncLocalStorage.getStore().set('traceId', uuid());
            if (traceId) {
                asyncLocalStorage.getStore().set('traceId', traceId);
            }
            return cb(...args);
        });
    }
    return cb(...args);
};
module.exports = {
    traceIdMiddleware,
    getTraceId,
    getStoreProperty,
    asyncLocalStorage,
    runCbWithTraceId,
    addPropsToContext,
};
//# sourceMappingURL=tracerService.js.map